import { render, staticRenderFns } from "./ImageBox.vue?vue&type=template&id=097f6b4c&"
import script from "./ImageBox.vue?vue&type=script&lang=js&"
export * from "./ImageBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports